import React from "react";
import { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useDispatch } from "react-redux";
import { clearRecurrenceData } from "../../../redux/slices/lomavisCreator/lomavisCreator";
import { useTranslate } from "@tolgee/react";
import { VIEW_STATUS } from "../config/constants";

const ToggleConfirmation = ({ handleClose, show, handleClear }) => {
  const dispatch = useDispatch();
  const { t } = useTranslate();
  return (
    <div>
      <Modal centered show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{t("sync_exit.confirmation.header")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{t("sync_exit.confirmation.main")}</Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => {
              handleClose();
            }}
            variant="secondary"
            size="sm"
          >
            {t("lomavisCreator.modal.doNotEnableSyncEdit")}
          </Button>
          <Button size="sm" variant="primary" onClick={() => {
            handleClose();
            handleClear();
          }}>
            {t("lomavisCreator.modal.enableSyncEdit")}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ToggleConfirmation;
